import { AutoThemeProvider } from '@platform-ui/design-system';
import React from 'react';
import GenericTable from '../Tables/components/GenericTable';
import { TASKS_TABLE_PROPS } from '../Tables/constants';

const TasksPartialView = (props) => {
    return (
        <AutoThemeProvider>
            <GenericTable {...TASKS_TABLE_PROPS} {...props} />
        </AutoThemeProvider>
    );
};

export default TasksPartialView;